<template>
  <!-- <div style="overflow-x: auto; max-width: 100%; width: 100%"> -->
  <table class="table" :id="id">
    <thead>
      <tr>
        <th
          v-for="(column, index) in columns"
          :key="index"
          :style="column.thStyle"
        >
          <slot :name="'header-' + column.key">
            {{ column.label }}
          </slot>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item, index) in data" :key="index" @click="$emit('clickRow', $event)">
        <td
          v-for="(column, indexColumn) in columns"
          :key="indexColumn"
          :style="column.tdStyle"
        >
          <slot :name="'cell-' + column.key" :data="item">
            {{ item[column.key] }}
          </slot>
        </td>
      </tr>

      <!-- Add caption into table by DuABi -->
      <tr v-if="items.length == 0">
        <td :colspan="fields.length">
          <slot name="empty_data">
            <div class="emptyData">
              <p>Không tìm thấy kết quả tìm kiếm</p>
            </div>
          </slot>
        </td>
      </tr>
    </tbody>
  </table>
  <!-- </div> -->
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: "",
    },

    items: {
      type: Array,
      default: () => [],
    },

    fields: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    columns: {
      get: function () {
        const fields = this.fields.map((e, index) => {
          return {
            ...e,
            thStyle: e.thStyle ? e.thStyle : "",
            tdStyle: e.tdStyle ? e.tdStyle : "",
            show: typeof e.show != "undefined" ? e.show : true,
          };
        });

        return fields.filter((e) => e.show == true);
      },
    },

    data: {
      get: function () {
        return this.items.map((e, index) => {
          return {
            ...e,
            index: index,
          };
        });
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.table {
  border: 1px solid #e1e4e9;
}

.emptyData {
  height: 300px;

  p {
    color: #ddd;
    font-weight: bold;
    font-size: 24px;
    text-align: center;
    padding-top: 165px;
  }
}
</style>